import script from "./SubFooterSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SubFooterSection.vue?vue&type=script&setup=true&lang=js"

import "./SubFooterSection.vue?vue&type=style&index=0&id=24a1b941&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24a1b941"]])

export default __exports__